if (!customElements.get('adev-facets')) {
    customElements.define('adev-facets', class adevFacets extends HTMLElement {
        constructor() {
            super();
        }

        handleOutsideClick(event) {
            if (!this.contains(event.target)) {
                this.closeAllDropdowns();
            }
        }

        refresh(){
            // this.form.submit();
            this.dispatchEvent(new Event('adev:change'));
        }

        closeAllDropdowns(){
            this.querySelectorAll('[data-adev-facet="dropdown"].active').forEach(tab => {
                tab.classList.remove('active');
            });

            this.querySelectorAll('[data-adev-facet="toggle"].active').forEach(tab => {
                tab.classList.remove('active');
            });
        }

        clearFilter(){
            this.form.reset();

            this.form.querySelectorAll('input[type="checkbox"]:checked').forEach(checkbox => {
                checkbox.checked = false;
            });

            this.form.querySelectorAll('input[type="number"]').forEach(input => {
                input.value = '';
            });

            this.refresh();
        }

        connectedCallback() {
            this.form = this.querySelector('form');

            this.form.addEventListener('submit', (event) => {
                event.preventDefault();
            });

            this.querySelectorAll('[data-adev-facet="toggle"]').forEach(button => {
                button.addEventListener('click', () => {
                    const id = button.dataset.id;
                    const tab = this.querySelector(`[data-adev-facet="dropdown"][data-id="${id}"]`);

                    if (!tab) return;

                    if (tab.classList.contains('active')) {
                        tab.classList.remove('active');
						button.classList.remove('active');
                        return;
                    }

					this.querySelectorAll('[data-adev-facet="toggle"].active').forEach(tab => {
						tab.classList.remove('active');
					});

                    this.querySelectorAll('[data-adev-facet="dropdown"].active').forEach(tab => {
                        tab.classList.remove('active');
                    });

					button.classList.add('active');
                    tab.classList.add('active');

                });
            });

            this.querySelectorAll('[data-adev-facet="clear"]').forEach(button => {
                button.addEventListener('click', () => {
                    this.closeAllDropdowns();
                    this.clearFilter();
                });
            });

            this.form.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
                checkbox.addEventListener('change', () => {
                    this.refresh();
                });
            });

            this.form.querySelectorAll('[data-adev-facet="save-price-range"]').forEach(button => {
                button.addEventListener('click', () => {
                    this.refresh();
                });
            });

            document.addEventListener('click', this.handleOutsideClick.bind(this));
        }

        disconnectedCallback() {
            document.removeEventListener('click', this.handleOutsideClick.bind(this));
        }

    });
}